import React, { useState } from 'react'

import Modal from '../../../../UI/Modal/Modal'
import Button from '../../../../UI/Button/Button'
import {
  Grid,
  Avatar,
  Typography,
  withStyles,
  TextField,
  Link,
  IconButton
} from '@material-ui/core'
import withTranslate from 'react-redux-multilingual/lib/withTranslate'
import moment from 'moment'
import FileInput from '../../../../UI/Forms/FileInput/FileInput'
import { DeleteRounded } from '@material-ui/icons'
import ConfirmationModal from '../../../../ConfirmationModal/ConfirmationModal'

function CommentModal({
  open,
  translate,
  commentSubmitted,
  commentList,
  closed,
  downloadClicked,
  deleteClicked
}) {
  const [commentContent, setCommentContent] = useState('')
  const [commentFile, setCommentFile] = useState(null)
  const [modalOpenState, setModalOpenState] = useState(false)
  const [deleteTargetId, setDeleteTargetId] = useState(null)

  const openConfirmModal = targetId => {
    setModalOpenState(true)
    setDeleteTargetId(targetId)
  }

  const closeConfirmModal = () => {
    setModalOpenState(false)
    setDeleteTargetId(null)
  }

  const commentDisplay = commentList.map(comment => (
    <CommentInfo
      key={comment.rkc_id || comment.rcc_id}
      commentInfo={comment}
      downloadClicked={downloadClicked}
      askConfirmation={targetId => openConfirmModal(targetId)}
    />
  ))
  return (
    <Modal
      onHide={closed}
      open={open}
      header={translate('comment')}
      footer={
        <Button
          style={{ width: 'inherit' }}
          color={'primary'}
          clicked={() => {
            closed()
            setCommentContent('')
            setCommentFile(null)
          }}>
          {translate('save')}
        </Button>
      }>
      <ConfirmationModal
        open={modalOpenState}
        confirmed={() => {
          deleteClicked(deleteTargetId)
          closeConfirmModal()
        }}
        cancelled={() => closeConfirmModal()}
        header={translate('deleteComment')}
        promptText={translate('confirmDel')}
      />
      {commentDisplay}
      <CommentActionControls
        commentContent={commentContent}
        commentChanged={comment => setCommentContent(comment)}
        commentFile={commentFile}
        commentFileChanged={file => setCommentFile(file)}
        commentSubmitted={() => {
          commentSubmitted(commentContent, commentFile)
          setCommentContent('')
          setCommentFile(null)
        }}
        translate={translate}
      />
    </Modal>
  )
}

const CommentInfo = ({ commentInfo, downloadClicked, askConfirmation }) => {
  const docPath = commentInfo?.doc_path || ''
  const downloadFile = (e, docPath) => {
    e.preventDefault()
    downloadClicked(commentInfo.rkc_id || commentInfo.rcc_id)
  }
  let deleteButton = null
  if (commentInfo?.deletable) {
    deleteButton = (
      <Grid item xs={1}>
        <IconButton
          size={'small'}
          color={'secondary'}
          onClick={() => askConfirmation(commentInfo.rkc_id || commentInfo.rcc_id)}>
          <DeleteRounded />
        </IconButton>
      </Grid>
    )
  }
  return (
    <Grid container direction={'row'} style={{ margin: 8 }}>
      <StyledGrid item>
        <Avatar
          src={commentInfo?.comment_by?.image_path}
          alt={commentInfo?.comment_by?.full_name}
        />
      </StyledGrid>
      <Grid container item xs sm md lg style={{ margin: '0 10px' }}>
        <Grid container item direction={'row'} alignItems={'flex-end'} justify={'space-between'}>
          <Grid container item xs>
            <Grid item>
              <Typography variant={'h6'}>{commentInfo?.comment_by?.full_name}</Typography>
            </Grid>
            <Grid item>
              <CommentByTypo variant={'caption'}>
                {moment(commentInfo?.created_at, 'YYYY-MM-DD hh:mm:ss').calendar()}
              </CommentByTypo>
            </Grid>
          </Grid>
          {deleteButton}
        </Grid>
        <Grid item xs sm md lg>
          <Typography>{commentInfo?.comment}</Typography>
          <Typography variant={'caption'}>
            <Link href={'#'} onClick={e => downloadFile(e, docPath)}>
              {docPath.slice(docPath.search('/') + 1)}
            </Link>
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  )
}

const CommentActionControls = ({
  commentContent,
  commentChanged,
  commentSubmitted,
  commentFile,
  commentFileChanged,
  translate
}) => {
  return (
    <Grid container direction={'column'} spacing={1}>
      <Grid item xs sm md lg>
        <TextField
          multiline
          variant={'outlined'}
          label={translate('comment')}
          value={commentContent}
          fullWidth
          onChange={e => commentChanged(e.target.value)}
        />
      </Grid>
      <Grid container item xs sm spacing={1}>
        <Grid item>
          <Button
            color={'primary'}
            clicked={commentSubmitted}
            disabled={!commentFile && !commentContent}>
            {translate('reply')}
          </Button>
        </Grid>
        <Grid item>
          <FileInput
            variant={'button'}
            selected={commentFile}
            changed={e => commentFileChanged(e.target.files[0])}
          />
        </Grid>
        <Grid container item sm alignItems={'flex-end'}>
          <Grid item>
            <Typography variant={'body2'}>{commentFile?.name || null}</Typography>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
}

const CommentByTypo = withStyles(theme => ({
  root: {
    display: 'flex',
    alignItems: 'flex-end',
    height: '100%',
    lineHeight: 2.2,
    margin: '0 5px'
  }
}))(Typography)

const StyledGrid = withStyles(theme => ({
  root: {
    padding: theme.spacing(1, 0)
  }
}))(Grid)

export default withTranslate(CommentModal)
